import { DsconfigService } from '@services/dsconfig/dsconfig.service';
import { DayData, ImputationsData } from '@components/calendar/calendar-day/calendar-day.model';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { RestConnService, StorageService } from '@services/services.module';
import { Constants } from '@app/constants/constants';

@Injectable({
  providedIn: 'root'
})
export class ModalMonthService {

  private monthly_imputation: object;
  private imputations: object;

  constructor(
    private dsConfig: DsconfigService,
    private _res: RestConnService,
    private storage: StorageService,
  ) {
    this.monthly_imputation = {
      'monthly_imputation': dsConfig.getUrlBase() + '/ess/v1/employee/imputation/monthly'
    };
    this.imputations = {
      'imputations': dsConfig.getUrlBase() + '/ess/v1/imputation/list'
    };
  }

  saveMonth(inputSaveEmployee: any): Observable<any> {
    const dataToSend = {
      imputationsEmployee: Object.assign([], inputSaveEmployee)
    };
    return this._res
      .post('monthly_imputation', dataToSend,
        {
          collection: this.monthly_imputation
        }
      );
  }
  deleteImputationSelected(inputationSelected: ImputationsData): Observable<any> {
    return this._res
    .post('imputations', {...{imputations: [inputationSelected.imputationId]}, ...{
      name: this.storage.get(Constants.UserData.employeeName),
      email: this.storage.get(Constants.UserData.email),
      employeeNumber: this.storage.get(Constants.UserData.employeeNumber),
      profileId: this.storage.get(Constants.UserData.profileId)
    }},
        {
          collection: this.imputations
        }
      );
  }
}
